module.exports = __webpack_public_path__ + "img/liga-portugal-1-23.e3649d01.png";